import React from 'react';
// Components
import ScheduledStreamsTable from 'components/common/ScheduledStreamsTable';

const ManageAthleteScheduledStreams: React.FC = () => {
  return <ScheduledStreamsTable />;
};

export default ManageAthleteScheduledStreams;
